import './Title.css.proxy.js';
/* src/components/block/Title.svelte generated by Svelte v3.35.0 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	safe_not_equal,
	set_data,
	set_style,
	text,
	transition_in,
	transition_out
} from "../../web_modules/svelte/internal.js";

import Wrap from "../slot/Wrap.js";

function create_default_slot(ctx) {
	let h1;
	let t0;
	let p;
	let t1;

	return {
		c() {
			h1 = element("h1");
			t0 = text(/*title*/ ctx[0]);
			p = element("p");
			t1 = text(/*en*/ ctx[1]);
			this.h();
		},
		l(nodes) {
			h1 = claim_element(nodes, "H1", { class: true });
			var h1_nodes = children(h1);
			t0 = claim_text(h1_nodes, /*title*/ ctx[0]);
			h1_nodes.forEach(detach);
			p = claim_element(nodes, "P", { class: true });
			var p_nodes = children(p);
			t1 = claim_text(p_nodes, /*en*/ ctx[1]);
			p_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(h1, "class", "svelte-1tgm711");
			attr(p, "class", "svelte-1tgm711");
		},
		m(target, anchor) {
			insert(target, h1, anchor);
			append(h1, t0);
			insert(target, p, anchor);
			append(p, t1);
		},
		p(ctx, dirty) {
			if (dirty & /*title*/ 1) set_data(t0, /*title*/ ctx[0]);
			if (dirty & /*en*/ 2) set_data(t1, /*en*/ ctx[1]);
		},
		d(detaching) {
			if (detaching) detach(h1);
			if (detaching) detach(p);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			div = element("div");
			create_component(wrap.$$.fragment);
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true, style: true });
			var div_nodes = children(div);
			claim_component(wrap.$$.fragment, div_nodes);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "title svelte-1tgm711");
			set_style(div, "background-image", "url(" + /*background*/ ctx[2] + ")");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(wrap, div, null);
			current = true;
		},
		p(ctx, [dirty]) {
			const wrap_changes = {};

			if (dirty & /*$$scope, en, title*/ 11) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);

			if (!current || dirty & /*background*/ 4) {
				set_style(div, "background-image", "url(" + /*background*/ ctx[2] + ")");
			}
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(wrap);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { title } = $$props;
	let { en } = $$props;
	let { background } = $$props;

	$$self.$$set = $$props => {
		if ("title" in $$props) $$invalidate(0, title = $$props.title);
		if ("en" in $$props) $$invalidate(1, en = $$props.en);
		if ("background" in $$props) $$invalidate(2, background = $$props.background);
	};

	return [title, en, background];
}

class Title extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { title: 0, en: 1, background: 2 });
	}
}

export default Title;
//# sourceMappingURL=Title.js.map
